
import {useStore} from "@/store";
import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";
import { Popover } from 'scvant';
interface InfoItem {
    code: string;
    name: string;
    value: string;
    showPopover?: boolean; // 可选属性
}
interface State {
    configInfo: InfoItem[];
    baseInfo:  InfoItem[];
    batteryBaseInfo:  InfoItem[];
    photoList:  object[];
    templateCode: string;
}
export default defineComponent({
        name: "promiseFrame",
        setup() {
            let state: State = reactive({
                configInfo: [],
                baseInfo: [],
                batteryBaseInfo: [],
                photoList: [],
                templateCode: ''
            })
            document.title = '车辆及三电基本信息';
            window.scrollTo(0,0);
            // let carInfo = localStorage.getItem('carInfo') || '';
            // console.log(carInfo);
            // state.configInfo = JSON.parse(carInfo).configureInfos;
            // state.baseInfo = JSON.parse(carInfo).basicItemInfos;
            let store = useStore()
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            watch(reportData, (data: any) => {
                const {componentList} = JSON.parse(JSON.stringify(data));
                const baseInfo = componentList.find(item => item.code === 'baseInfo');
                baseInfo && baseInfo.configItems.map((item) => {item.showPopover = false;});
                
                const configInfo = componentList.find(item => item.code === 'configInfo');
                configInfo && configInfo.configItems.map((item) => {item.showPopover = false;});
                
                const batteryBaseInfo = componentList.find(item => item.code === 'batteryBaseInfo');
                batteryBaseInfo && batteryBaseInfo.configItems.map((item) => {item.showPopover = false;});
                
                state.baseInfo = baseInfo && baseInfo.configItems;
                state.configInfo = configInfo && configInfo.configItems;
                state.batteryBaseInfo = batteryBaseInfo && batteryBaseInfo.configItems;
            }, {immediate: true, deep: true})
            window.document.addEventListener('click', () => {
                console.log('click');
                 state.baseInfo.forEach((item) => {
                    item.showPopover = false;
                });
                state.configInfo.forEach((item) => {
                    item.showPopover = false;
                });
                state.batteryBaseInfo.forEach((item) => {
                    item.showPopover = false;
                });
            });
            return {
                state
            }
        },
        components: {
            [Popover.name]: Popover,
        },
        methods: {
            changePopoverState(item) {
                if (item.value.length < 8) {
                    return;
                }
                this.state.baseInfo.forEach((item) => {
                    item.showPopover = false;
                });
                this.state.configInfo.forEach((item) => {
                    item.showPopover = false;
                });
                this.state.batteryBaseInfo.forEach((item) => {
                    item.showPopover = false;
                });
                if (item.value.length >= 9 && item.code !== 'VIN') {
                    item.showPopover = true;
                }
            },
            setClass(index) {
                if ((index + 1)%4 === 0) {
                    return 'right';
                } else if ((index + 1)%4 === 1) {
                    return 'left';
                }
            }
        },
        beforeUnmount () {
            localStorage.removeItem('carInfo');
        },
    })
